// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApitypesTotalPerDay } from './ApitypesTotalPerDay';
import {
  ApitypesTotalPerDayFromJSON,
  ApitypesTotalPerDayFromJSONTyped,
  ApitypesTotalPerDayToJSON,
  ApitypesTotalPerDayToJSONTyped,
} from './ApitypesTotalPerDay';

/**
 *
 * @export
 * @interface ApitypesEnvironmentsCostsSummaryResponse
 */
export interface ApitypesEnvironmentsCostsSummaryResponse {
  /**
   *
   * @type {number}
   * @memberof ApitypesEnvironmentsCostsSummaryResponse
   */
  averageTotalCostPerDay?: number;
  /**
   *
   * @type {number}
   * @memberof ApitypesEnvironmentsCostsSummaryResponse
   */
  maxTotalCostPerDay?: number;
  /**
   *
   * @type {number}
   * @memberof ApitypesEnvironmentsCostsSummaryResponse
   */
  minTotalCostPerDay?: number;
  /**
   *
   * @type {number}
   * @memberof ApitypesEnvironmentsCostsSummaryResponse
   */
  totalCost?: number;
  /**
   *
   * @type {Array<ApitypesTotalPerDay>}
   * @memberof ApitypesEnvironmentsCostsSummaryResponse
   */
  totalsPerDay?: Array<ApitypesTotalPerDay>;
}

/**
 * Check if a given object implements the ApitypesEnvironmentsCostsSummaryResponse interface.
 */
export function instanceOfApitypesEnvironmentsCostsSummaryResponse(
  value: object,
): value is ApitypesEnvironmentsCostsSummaryResponse {
  return true;
}

export function ApitypesEnvironmentsCostsSummaryResponseFromJSON(
  json: any,
): ApitypesEnvironmentsCostsSummaryResponse {
  return ApitypesEnvironmentsCostsSummaryResponseFromJSONTyped(json, false);
}

export function ApitypesEnvironmentsCostsSummaryResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApitypesEnvironmentsCostsSummaryResponse {
  if (json == null) {
    return json;
  }
  return {
    averageTotalCostPerDay:
      json['averageTotalCostPerDay'] == null
        ? undefined
        : json['averageTotalCostPerDay'],
    maxTotalCostPerDay:
      json['maxTotalCostPerDay'] == null
        ? undefined
        : json['maxTotalCostPerDay'],
    minTotalCostPerDay:
      json['minTotalCostPerDay'] == null
        ? undefined
        : json['minTotalCostPerDay'],
    totalCost: json['totalCost'] == null ? undefined : json['totalCost'],
    totalsPerDay:
      json['totalsPerDay'] == null
        ? undefined
        : (json['totalsPerDay'] as Array<any>).map(ApitypesTotalPerDayFromJSON),
  };
}

export function ApitypesEnvironmentsCostsSummaryResponseToJSON(
  json: any,
): ApitypesEnvironmentsCostsSummaryResponse {
  return ApitypesEnvironmentsCostsSummaryResponseToJSONTyped(json, false);
}

export function ApitypesEnvironmentsCostsSummaryResponseToJSONTyped(
  value?: ApitypesEnvironmentsCostsSummaryResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    averageTotalCostPerDay: value['averageTotalCostPerDay'],
    maxTotalCostPerDay: value['maxTotalCostPerDay'],
    minTotalCostPerDay: value['minTotalCostPerDay'],
    totalCost: value['totalCost'],
    totalsPerDay:
      value['totalsPerDay'] == null
        ? undefined
        : (value['totalsPerDay'] as Array<any>).map(ApitypesTotalPerDayToJSON),
  };
}
